module.exports = __webpack_public_path__ + "static/media/perche-3.4cfbd7ff.svg";